import type { TextFieldProps } from '@mui/material';
import { TextField as MuiTextField } from '@mui/material';

import { useFieldContext } from '@/hooks/useFieldContext';

export function TextField({ type = 'text', ...props }: TextFieldProps) {
  const field = useFieldContext<string>();

  let error: string | undefined;
  if (typeof field.state.meta.errors[0] === 'string') {
    [error] = field.state.meta.errors;
  } else if (field.state.meta.errors[0] && 'message' in field.state.meta.errors[0]) {
    error = field.state.meta.errors[0].message;
  }

  return (
    <MuiTextField
      fullWidth
      error={!!field.state.meta.errors.length}
      helperText={error}
      name={field.name}
      onBlur={field.handleBlur}
      onChange={(event) => field.handleChange(event.target.value)}
      type={type}
      value={field.state.value ?? ''}
      {...props}
    />
  );
}
